function upTo(el, tagName) {
  tagName = tagName.toLowerCase();

  while (el && el.parentNode) {
    el = el.parentNode;
    if (el.tagName && el.tagName.toLowerCase() === tagName) {
      return el;
    }
  }

  return null;
}

const update_ui = debounce((ev) => {
  console.log('page is resized');
}, 250);

window.addEventListener('resize', update_ui);

window.addEventListener("orientationchange", function (event) {
  console.log("the orientation of the device is now " + event.target.screen.orientation.angle);
});

document.addEventListener("DOMContentLoaded", function () {



  document.querySelectorAll( '#search-toggle' ).forEach( function( item2, index2 ) {
    item2.addEventListener( 'click', function( e ) {
      var selector = item2.dataset[ 'id' ];
      console.log('queryselector: ' + document.querySelector( selector ).classList);
      document.querySelector( selector ).classList.toggle( 'show' );
      document.querySelector( selector + ' .search-field' ).focus();
      item2.classList.toggle( 'active' );
      e.preventDefault();
    } )
  } )


  document.querySelectorAll('.google-map-link').forEach(item => {
    item.addEventListener('click', event => {
      event.preventDefault();
      let mapframe = document.createElement('iframe');
      mapframe.src = item.getAttribute('data-url');
      mapframe.setAttribute('width', item.getAttribute('data-width'));
      mapframe.setAttribute('height', item.getAttribute('data-height'));
      mapframe.setAttribute('allowfullscreen', '');
      mapframe.setAttribute('loading', 'lazy');
      item.replaceWith(mapframe);
    })
  })

  document.querySelectorAll('.dropdown-toggle').forEach(item => {
    item.innerHTML += '<span class="caret sub-arrow"></span>';
  })

  document.querySelectorAll('figure:not(.wp-block-table) a').forEach(item => {
    item.className += 'glightbox';
  })

  document.querySelectorAll('.caret').forEach(item => {
    item.addEventListener('click', event => {
      event.preventDefault();

      item.classList.toggle('open');

      let parent = upTo(item, 'a');
      if (parent) {
        let sibling = parent.nextElementSibling;
        if (sibling) {
          sibling.style.display = sibling.style.display !== 'block' ? 'block' : 'none';
        }
      }
    })
  })
});

window.addEventListener('load', (event) => {
  console.log('page is fully loaded...');
  const lightbox = GLightbox({
    touchNavigation: true,
    loop: true,
    autoplayVideos: true
  });
});
